import ValidationInterface from '@/plans/common/validation-interface';
import { basePlanCategories } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires() {
    return [this.current('ZCM').require(basePlanCategories)];
  }

  async conflicts() {
    return this.current(['ZCM']).conflict(['ZCM']);
  }
}
